import { render } from "./retailerstable.vue?vue&type=template&id=4ca3decc&scoped=true"
import script from "./retailerstable.vue?vue&type=script&lang=js"
export * from "./retailerstable.vue?vue&type=script&lang=js"

import "./retailerstable.vue?vue&type=style&index=0&id=4ca3decc&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca3decc"]])

export default __exports__